import { render, staticRenderFns } from "./CzIsco.vue?vue&type=template&id=516fbfca&"
import script from "./CzIsco.vue?vue&type=script&lang=js&"
export * from "./CzIsco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CzIsco.vue"
export default component.exports